import UtilApi from '@/api/util';

export default {
  namespaced: true,

  state: {
    uploadResponse: null,
    location: null,
    searchQuery: null,
    loading: false,
    error: null,
  },

  actions: {
    async getCoords(ctx, address) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await UtilApi.getCoords(address);

        const entity = response.data[0];

        const location =  { lat: entity.lat, lon: entity.lon };
        ctx.commit('setLocation', location);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async uploadStaticFile(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await UtilApi.uploadStaticFile(data);
        ctx.commit('setUploadResponse', response);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async updateStaticFile(ctx, data) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const response = await UtilApi.updateStaticFile(data);
        ctx.commit('setUploadResponse', response);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async removeStaticFile(ctx, url) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        await UtilApi.removeStaticFile(url);
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    changeQuery(ctx, query) {
      ctx.commit('setSearchQuery', query);
    },
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setLocation(state, location) {
      state.location = location;
    },

    setSearchQuery(state, query) {
      state.searchQuery = query;
    },

    setUploadResponse(state, data) {
      state.uploadResponse = data;
    },
  },

  getters: {
    uploadResponse: state => state.uploadResponse,
    searchQuery: state => state.searchQuery,
    loading: state => state.loading,
    location: state => state.location,
  },
};
